import React, {useEffect, useState} from "react";
import InfoTooltip from "../tooltips/InfoTooltip";
import RadioFields from "../fields/RadioFields";
import {Field, useForm, useFormState} from "react-final-form";
import SelectField from "../fields/SelectField";
import {useSelector} from "react-redux";
import {optionItemFinder} from "../../helpers/OptionHelper";
import useIsMobile from "../../helpers/MobileHelper";
import WindowWidthProvider from "../../helpers/WindowWidthProvider";
import QueryStorage from "../../../../../common/helpers/QueryStorage";

function AcademicLevel() {
    const options = useSelector(state => state.orderOptions.data.academicLevel);
    const paperOptions = useSelector(state => state.orderOptions.data.typeOfPaper);
    const subjectOptions = useSelector(state => state.orderOptions.data.subject);
    const {values: {typeOfPaper, subject, academicLevel}, modified} = useFormState();
    const {change} = useForm();
    const [customOptions, setCustomOptions] = useState([]);
    const [isInitialized, setIsInitialized] = useState(false);
    const isMobile = useIsMobile();
    const windowWidth = WindowWidthProvider();

    const findMinAttributeValue = (attribute, minValue, paperItem, subjectItem) => {
        const paperValue = paperItem ? paperItem.academic[attribute] : minValue;
        const subjectValue = subjectItem ? subjectItem.academic[attribute] : minValue;

        const academicNumber = options.reduce((data, item, index) => {
            data[item.value] = index;
            return data;
        }, {})

        minValue = paperValue;
        if (academicNumber[paperValue] < academicNumber[subjectValue]) {
            minValue = subjectValue;
        }

        return minValue;
    }

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        let urlAcademicLevel = urlParams.get("academicLevel");
        if (urlAcademicLevel === "HighSchool") {
            urlAcademicLevel = "High School";
        }
        const savedAcademicLevel = QueryStorage.get("academicLevel");

        if (urlAcademicLevel) {
            change("academicLevel", urlAcademicLevel);
            QueryStorage.set("academicLevel", urlAcademicLevel);
        } else if (savedAcademicLevel) {
            change("academicLevel", savedAcademicLevel);
        }

        setIsInitialized(true);
    }, [change]);

    useEffect(() => {
        if (!isInitialized) return;

        const paperItem = optionItemFinder(typeOfPaper, paperOptions);
        const subjectItem = optionItemFinder(subject, subjectOptions);
        const minOptionValue = findMinAttributeValue('min', 'High School', paperItem, subjectItem);
        const defaultOptionValue = findMinAttributeValue('default', 'High School', paperItem, subjectItem);

        let isOptionDisabled = true;
        const updatedOptions = options.map(option => {
            if (option.value === minOptionValue) {
                isOptionDisabled = false
            }

            return {
                ...option,
                disabled: isOptionDisabled,
            };
        })

        setCustomOptions(updatedOptions);

        const currentOption = updatedOptions.find(option => option.value === academicLevel);
        if (!currentOption || currentOption.disabled) {
            change("academicLevel", defaultOptionValue);
        }

        if (modified.typeOfPaper || modified.subject) {
            if (!academicLevel) {
                change("academicLevel", defaultOptionValue);
            }
        }
    }, [typeOfPaper, subject, isInitialized]);

    useEffect(() => {
        if (modified.academicLevel) {
            QueryStorage.set("academicLevel", academicLevel);
        }
    }, [academicLevel, modified.academicLevel]);

    return <div className="form-group dd-form-group">
        <div className="form-label d-flex">
            Academic level
            <InfoTooltip>
                <p>
                    High school: Secondary education<br/>
                    College: 2-year degree programs<br/>
                    University: Undergraduate and Graduate degree<br/>
                    Master's: Postgraduate degree<br/>
                    PhD: The Doctorate of Philosophy<br/>
                </p>
            </InfoTooltip>
        </div>
        {!isMobile ? <RadioFields
            name="academicLevel"
            options={customOptions}
        /> : <Field
            name="academicLevel"
            component={SelectField}
            isSearchable={false}
            currentWidth={windowWidth}
            options={customOptions}
        />}
    </div>
}

export default AcademicLevel;
